import http from "./HttpService";

const apiEndPoint = "/betrieb";

/**
 * Sucht nach allen Betrieben und hängt die Suchparameter als Queryparameter an.
 * @param params
 * @returns {String}
 */
export function getBetriebeEndpoint(params) {
    return apiEndPoint + "/search" + (params ? "?" + params : "");
}

/**
 * Gibt alle Betriebe mit ID und Bezeichnung zurück.
 * @returns {string}
 */
export function getBetriebAuswahlEndpoint() {
    return apiEndPoint + "/auswahl/";
}

export function getBescheideByBBetriebEndpoint(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/bescheid/";
}

export function getBetriebsInfoEndpoint(id) {
    return apiEndPoint + "/" + id + "/info/";
}

export function getExportEntlastungsanlagenEndpoint(id) {
    return apiEndPoint + "/" + id + "/export-entlastungsanlagen/";
}

export function postImportEntlastungsanlagenEndpoint(id) {
    return apiEndPoint + "/" + id + "/import-entlastungsanlagen/";
}

export function postDruckausgabe(id, fachobjekte) {
    return {url: apiEndPoint + "/" + id + "/print/", method: "POST", data: fachobjekte, responseType: "blob"};
}

export function getBetriebKatalogEndpoint(id) {
    return apiEndPoint + "/" + id + "/betriebkatalog/";
}

export function getBetriebsDateienEndpoint(id) {
    return apiEndPoint + "/" + id + "/dateien/";
}

export function getBetriebDateiUploadEndpoint(id) {
    return apiEndPoint + "/" + id + "/upload-file/";
}

export function postBetrieb(betrieb) {
    return http.post(apiEndPoint + "/", betrieb);
}

export function getBetriebEndpoint(id) {
    return apiEndPoint + "/" + id;
}

export function postBetriebeExportEndpointConfiguration(selectedIds) {
    return {
        url: apiEndPoint + "/export/",
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function postBetriebeExportAllEndpointConfiguration(params) {
    return {
        url: apiEndPoint + "/export" + (params ? "?" + params : ""),
        method: "POST",
        responseType: "blob",
    };
}

export function postStammdaten(betriebsdaten, id) {
    return http.post(apiEndPoint + "/" + id + "/stammdaten/", betriebsdaten);
}

export function getStammdatenAntragEndpoint(id) {
    return apiEndPoint + "/" + id + "/stammdaten-antrag/";
}

export function deleteStammdatenAntrag(id) {
    return http.delete(apiEndPoint + "/" + id + "/stammdaten-antrag/");
}

export function putBetriebsdaten(betriebsdaten) {
    return http.put(apiEndPoint + "/" + betriebsdaten.id + "/betriebsdaten/", betriebsdaten);
}

export function putBetrieb(betriebsdaten) {
    return http.put(apiEndPoint + "/" + betriebsdaten.id, betriebsdaten);
}

export const getBearbeiter = "/bearbeiter/";

export function postFreigabe(freigabe) {
    return http.post(apiEndPoint + "/freigabe/", freigabe);
}

export function getIsBetreiberAbwsserbeseitigungspflichtigerInAnlageEndpoint(betriebId) {
    return apiEndPoint + "/" + betriebId + "/isBetreiberAbwasserbeseitigungspflichtigerInAnlage/";
}

export function getAbwasseranlagenToChangeOnStillegen(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/abwasserbehandlungForStilllegung/";
}

export function getAlternativeAbwasseranlagenAndererBetriebe(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/alternativeAbwasserbehandlungsanlagen/";
}

export function getBetriebHistorie(id) {
    return apiEndPoint + "/" + id + "/historie/";
}

export function postWiedervorlageForBetriebEndpoint(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/wiedervorlage/";
}

export function getWiedervorlageForBetriebEndpoint(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/wiedervorlage/";
}

export function getBetriebsMessstellenEndpoint(betriebsId) {
    return apiEndPoint + "/" + betriebsId + "/messstelle/";
}
